<template>
  <section>
    <div class="topNav">
      <div class="content">
        <img class="log" src="@/assets/images/logo.jpg" @click="$router.push('/')" alt="舟恩Logo" />
        <div class="item" v-for="item in navList" >
            {{item.name}} <span class="icon"></span>
            <div class="eNav">
              <div class="navItem" v-for="it in item.list" @click="$router.push('/' + it.url)">
                <img :src="require('@/assets/images/nav/'+it.icon)" />
                <span v-text="it.name"></span>
              </div>
            </div>
        </div>
        <div class="item" @click="$router.push('gywm')">
          关于我们 
        </div>
        <div class="navbar" @click="mobile" :class="{'is-active':isChoose}">
          <span></span>
          <span></span>
          <span></span>
      </div>
      </div>
    </div>
    <div class="nav_box" :class="{'cur':isChoose}">
      <div class="box">
          <!-- <div class="clearfix top-logo">
              <img class="mobile-logo" src="@/assets/images/log.png" @click="$router.push('/')" alt="">
          </div> -->
          <div class="navlist">
              <ul class="clearfix">
                <li v-for="moitem in navList">
                  {{moitem.name }} <span class="icon"><img src="@/assets/images/icon_jt.png" alt=""></span>
                  <ul class="sub-menu">
                    <li v-for="it in moitem.list" @click="$router.push('/' + it.url)">
                      <span v-text="it.name"></span>
                    </li>
                  </ul>
                </li>
                <li @click="$router.push('gywm')">
                  关于我们 
                </li>
              </ul>
          </div>
      </div>
    </div>
    <router-view :key="key" />
    <div class="footer">
      <div class="content">
        <div class="itemLine ml2">
          <div class="itemTitle">服务</a></div>
          <div class="item"><a href="#/zx">咨询</a></div>
          <div class="item"><a href="#/cs">测试</a></div>
          <div class="item"><a href="#/yykf">应用开发</a></div>
        </div>
        <div class="itemLine w10">
          <div class="itemTitle">产品</div>
          <div class="item"><a href="#/rpa">RPA</a></div>
          <div class="item"><a href="#/sjkgj">数据库工具</a></div>
          <!-- <div class="item">大数据平台</div> -->
        </div>
        <div class="itemLine">
          <div class="itemTitle"></div>
          <div class="item"><a href="#/zdhcs">自动化测试</a></div>
          <div class="item"><a href="#/sjfxl">数据防泄漏</a></div>
        </div>
        <div class="itemLine w10">
          <div class="itemTitle">解决方案</div>
          <div class="item"><a href="#/fdc">房地产</a></div>
          <div class="item"><a href="#/jr">金融</a></div>
          <div class="item"><a href="#/qc">汽车</a></div>
          <div class="item"><a href="#/kx">快消</a></div>
          <!-- <div class="item">互联网行业</div> -->
          <!-- <div class="item">新零售行业</div> -->
        </div>
        <div class="itemLine">
          <div class="itemTitle"></div>
          <div class="item"><a href="#/jk">健康</a></div>
          <div class="item"><a href="#/xny">新能源</a></div>
          <div class="item"><a href="#/ky">康养</a></div>
        </div>
        <div class="itemLine right">
          <div class="itemTitle">关于舟恩 <label style="padding-left: 20px;cursor: pointer;" onclick="javascript:window.open('https://wxkq.arkgrace.com/AGExtWebSub/login.aspx');">员工入口</label></div>
          <div class="item">上海舟恩信息技术有限公司（简称“舟恩信息”），于2014年6月注册成立，公司秉承 “诚信、执着、卓越、致远”的理念，以“客户满意、员工爱戴、同行尊敬”为目标，致力于为金融、健康、能源、汽车、房地产、互联网、新零售等行业提供综合性IT解决方案与咨询服务<br /><a @click="$router.push('gywm')" style="cursor: pointer;font-size: 11px;">MORE</a></div>
        </div>
      </div>
      <div class="bottonLine">
        <img class="gh" src="@/assets/images/gh.png" />
        <span>沪公网安备 31011502007080号 Copyright © 2022 <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022026115号</a></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IndexNull',
  data() {
      return {
          navList: [
            {name: '服务', list: [
              {icon: 'fu1.png', name: '咨询', url: 'zx'},
              {icon: 'fu2.png', name: '测试', url: 'cs'},
              {icon: 'fu3.png', name: '应用开发', url: 'yykf'}
            ]},
            {name: '产品', list: [
              {icon: 'cp1.png', name: 'RPA', url: 'rpa'},
              {icon: 'cp2.png', name: '自动化测试', url: 'zdhcs'},
              {icon: 'cp3.png', name: '数据库工具', url: 'sjkgj'},
              {icon: 'cp4.png', name: '数据防泄漏', url: 'sjfxl'}
            ]},
            {name: '解决方案', list: [
              {icon: 'jj1.png', name: '房地产', url: 'fdc'},
              {icon: 'jj2.png', name: '健康', url: 'jk'},
              {icon: 'jj3.png', name: '金融', url: 'jr'},
              {icon: 'jj4.png', name: '新能源', url: 'xny'},
              {icon: 'jj5.png', name: '汽车', url: 'qc'},
              {icon: 'jj6.png', name: '康养', url: 'ky'},
              {icon: 'jj7.png', name: '快消', url: 'kx'}
            ]}
          ],
          navOffsetTop: 0,
          isChoose : false
      }
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {
    mobile() {
      this.isChoose = !this.isChoose
    },
    getData () {
      this.navOffsetTop = document.querySelector('.topNav').offsetTop
    },
    fiexdNav () {
      // 2.获取当前页面的卷曲高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const nav = document.querySelector('.topNav')
      // 3.判断卷曲高度是否大于等于导航条的offsetTop值
      if (scrollTop > this.navOffsetTop) {
        //   3.1若满足，则给nav导航添加固定样式
        nav.classList.add('fixedNav')
      } else {
        //   3.2若不满足，则删除nav导航的固定样式
        nav.classList.remove('fixedNav')
      }

      /** 当滚动到一定区域时给导航项添加选中样式 **/
      //  1.获取所有锚点元素
      const contents = document.querySelectorAll('.about-content>div')
      // 2.获取锚点元素的offsetTop值，并收集在一个数组
      const contentsOffsetTop = []
      contents.forEach(item => {
        contentsOffsetTop.push(item.offsetTop)
      })
      // 3.获取页面高度
      const pageHeight = window.innerHeight
      // 4.获取nav的子元素
      const navChildren = document.querySelectorAll('.nav .item')
      // 5.遍历锚点元素的offsetTop值
      for (let i = 0; i < contentsOffsetTop.length; i++) {
        // 5.1 设置第一项导航默认为选中状态
        if (i === 0) {
          navChildren[0].classList.add('active')
        } else if (scrollTop > contentsOffsetTop[i - 1] + pageHeight / 3) {
          // 排他思想
          for (let j = 0; j < contentsOffsetTop.length; j++) {
            navChildren[j].classList.remove('active')
            navChildren[i].classList.add('active')
          }
        } else {
          navChildren[i].classList.remove('active')
        }
      }
    },
    /**
     *设置点击导航跳转到指定选择器对应的锚点元素
     * @param {*} selector
     **/
    skipTo (selector) {
      const navHeight = document.querySelector('.topNav').offsetHeight
      // scrollIntoView() js原生方法，实现锚点滚动过渡
      const target = document.querySelector(selector)
      target.scrollIntoView({ behavior: 'smooth' })
      // scrollTo() 把内容滚动到指定的坐标。减去导航高度的目的：导航用定位固定在顶部，如果不减去，导航栏会遮挡一部分内容
      window.scrollTo(0, target.offsetTop - navHeight)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.fiexdNav)
    this.getData()
  },
  destroyed () {
    window.removeEventListener('scroll', this.fiexdNav)
  }
}

</script>

<style lang="less" scoped>
.topNav {
  background: #fff;
  z-index: 10;
  position: relative;
  padding: 10px 0;
  .log {
    height: 50px;
    padding: 0 80px 0 20px;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }
  .item {
    display: inline-block;
    line-height: 50px;
    margin-right: 35px;
    position: relative;
    cursor: pointer;
    height: 50px;
    vertical-align: bottom;
    font-size: 16px;
    .icon img {
      display: inline-block;
      background-size: 110% auto;
      height: 14px;
      width: 16px;
    }

    .eNav {
      position: absolute;
      padding: 10px 0;
      line-height: normal;
      font-size: 16px;
      left: -30px;
      border: 1px solid #E2E2E2;
      display: none;
      top: 45px;
      width: 150px;
      border-radius: 8px;
      color: #333333;
      z-index: 9999;
      background-color: #ffffff;
      .navItem {
        padding: 0 15px;
        font-size: 14px;
        img {
          width: 25px;
          height: 25px;
        }
        span {
          display: inline-block;
          line-height: 35px;
          vertical-align: bottom;
          text-indent: 10px;
        }
      }
      .navItem:hover {
        background-color: #f7f7f7;
      }
    }
  }
  .item:hover {
    color: #F40010;
    .icon {
      // -moz-transform: rotate(-90deg);
      // -o-transform: rotate(-90deg);
      // -webkit-transform: rotate(-90deg);
      // transform: rotate(-90deg);
      background-position-y: -16px;
    }
    .eNav {
      display: block;
    }
  }
}

.nav_box {
	width: 100%;
	height: 100%;
	position: fixed;
	right: auto;
	top: 0;
	bottom: 0;
	left: -100%;
	overflow: auto;
	z-index: 99999999;
	background: rgba(50,58,67,.93);
  z-index: 8;
  .box{
    /*background: #212222;*/
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    padding-top: 65px;
  }
  .nav-title {
    height: 57px;
    position: relative;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    opacity: 0;
    visibility: hidden;
      .navclose {
        width: 22px;
        height: 22px;
        display: block;
        font-size: 0;
        line-height: 41px;
        position: absolute;
        right: 15px;
        top: 50%;
        z-index: 2;
        transform: translateY(-50%);
        img {
          width: 100%;
        }
      }
      h1 {
        text-align: left;
        width: 68px;
        margin-left: 15px;
        line-height: 0;
        padding-top: 11px;
        img {
          width: 100%;
        }
      }
  }
  .top-logo {
    width: 100%;
    height: 60px;
    padding: 0 50px;
    display: block;
    color: #fff;
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .mobile-logo {
    max-width: 100%;
    height: 40px;
  }
  .navlist {
    width: 100%;
    ul.clearfix>li {
      float: left;
      width: 100%;
      font-size: 16px;
      line-height: 60px;
      border-bottom: 1px solid rgba(255, 255, 255, .06);
      padding: 0 50px;
      text-transform: capitalize;
      display: block;
      color: #fff;
      position: relative;
      box-sizing: border-box;
      span.icon {
        position: absolute;
        right: 65px;
        width: 8px;
        height: 14px;
      }
    }
    ul.clearfix>li:hover span.icon img {
      transform: rotate(90deg);
      transition: all .5s;
    }
    >ul.clearfix>li ul.sub-menu {
      border-top: 1px solid rgba(255, 255, 255, .06);
      display: none;
      padding: 5px 0 10px;
      transition: none;
    }
    >ul.clearfix>li:hover ul.sub-menu {
      display: block;
    }
    >ul.clearfix>li ul.sub-menu li {
      list-style: none;
      display: block;
      width: 100%;
      color: #fff;
      font-size: 14px;
      line-height: 34px;
    }
  }
  .nav_box{
    transition: all .8s;
  }
}
.nav_box.cur{
  left: 0;
  transition: all .8s;
  z-index: 9;
}
.navbar {
  width: 30px;
  cursor: pointer;
  display: none;
  position: absolute;
  right: 50px;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
}


.navbar span:nth-of-type(1),.navbar span:nth-of-type(2),.navbar span:nth-of-type(3) {width: 20px; height: 2px; background-color: #000000; border-radius: 3px; position: absolute;transition: transform 0.15s ease;}
.navbar span:nth-of-type(2),.navbar span:nth-of-type(3) { content: ""; display: block;}
.navbar span:nth-of-type(2) {top: -8px;}
.navbar span:nth-of-type(3) {bottom: -7px;}
.navbar span:nth-of-type(1) {top: 50%; margin-top: -1.5px; transition-duration: 0.3s;transition-timing-function: cubic-bezier(0.55,0.055,0.675,0.19);}
.navbar span:nth-of-type(2) {transition: top 0.1s 0.34s ease-in,opacity 0.1s ease-in,background-color 0.15s ease}
.navbar span:nth-of-type(3) {transition: bottom 0.1s 0.34s ease-in,transform 0.3s cubic-bezier(0.55,0.055,0.675,0.19) ,background-color 0.15s ease}
.navbar.is-active span {}
.navbar.is-active span:nth-of-type(1){transform: rotate(225deg);transition-delay: 0.14s;transition-timing-function: cubic-bezier(0.215,0.61,0.355,1);}
.navbar.is-active span:nth-of-type(2) {top: 0;opacity: 0;transition: top 0.1s ease-out,opacity 0.1s 0.14s ease-out,background-color 0.15s ease;}
.navbar.is-active span:nth-of-type(3) {bottom: 0;transform: rotate(-50deg);transition: bottom 0.1s ease-out,transform 0.3s 0.14s cubic-bezier(0.215,0.61,0.355,1),background-color 0.15s ease;}
.footer {
  background-color: #000000;
  color: #FEFEFE;
  .content {
    zoom: 1;
    overflow: hidden;
    padding: 20px 0 40px;
    .itemLine {
      float: left;
      width: 15%;
      a {
        color: #999999;
        text-decoration: none;
      }
      a:active {
        color: #ffffff;
      }
      .itemTitle {
        height: 40px;
        font-size: 14px;
      }
      .item {
        line-height: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        padding: 5px 0;
        color: #999999;
      }
    }
    .w10 {
      width: 10%;
    }
    .ml2 {
      margin-left: 2%;
    }
    .right {
      float: right;
      width: 31%;
      margin-right: 2%;
    }
  }
  .bottonLine {
    text-align: center;
    background-color: #181818;
    padding: 10px;
    span {
      opacity: 0.2;
      font-size: 12px;
      font-family: PingFang SC;
      line-height: 25px;
      vertical-align: bottom;
      a {
        color: #ffffff;
        text-decoration:none;
      }
    }
    img {
      height: 20px;
      margin-right: 6px;
    }
  }
}
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .topNav .log {
    padding: 0 60px 0 0;
  }
}
@media (max-width: 960px) {
  .topNav{
    .item {
      display: none;
    }
   .log {
      height: 40px;
      padding: 0 30px 0 0;
    }
  }
  .navbar {
    display: block;
  }
}
@media (max-width: 768px) {
  .fixedNav {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    box-shadow: 0 0 15px rgba(0,0,0,.1);
  }
  .active {
    
  }
  .navbar {
    right: 15px;
  }
  .nav_box {
    overflow: hidden;
    .top-logo {
      padding: 0 15px;
    }
    .navlist ul.clearfix > li {
      padding: 0 15px;
    }
    .navlist ul.clearfix > li span.icon{
      right: 30px;
    }
  }
  .footer .content {
    display: none;
  }
}
</style>